import { AmbientLight, PointLight, FogExp2 } from 'three';

import store from '@/store';
import Scene from './Scene';
import Camera from './Camera';
import Renderer from './Renderer';
import Raycasting from './Raycasting';
import Interface from '@/scripts/Interface';
import { getGroup } from '@/scripts/groupUtils';
import Cursor from '../Cursor';


export default class Stage {
  constructor(DOMContainer) {
    this.DOMContainer = DOMContainer;
    this.DOMRect = this.DOMContainer.getBoundingClientRect();

    this.time = 0;
    this.counter = 0;

    // set renderer
    Renderer.setSize(window.innerWidth, window.innerHeight);
    Renderer.setPixelRatio(1.5, window.devicePixelRatio || 1);
    Renderer.gammaOutput = true;
    Renderer.gammaFactor = 2.2;
    this.DOMContainer.appendChild(Renderer.domElement);

    // add more light to the scene
    const ambientLight = new AmbientLight(0x431c77);
    const light = new PointLight(0xE092FF, 1, 100);
    light.position.set(8, 8, 10);

    // set scene
    Scene.add(ambientLight);
    Scene.add(light);
    Scene.fog = new FogExp2(0x1b1b1b, 0.04);
  }

  render(time) {
    this.time += time;

    const currentGroup = getGroup.byIndex(Interface.currentIndex);
    const intersectGroup = currentGroup.clones;
    if (Cursor.ref !== null && intersectGroup !== null) {
      Raycasting.calculateIntersections(
        Cursor.ref,
        Camera,
        intersectGroup,
      );

      if (!store.state.isInTransition) {
        this.counter += 1;

        if (this.counter > 0) {
          currentGroup.model.position.y += Math.cos(this.time * 0.0005) / 500;
          currentGroup.model.position.x += Math.sin(this.time * 0.0008) / 500;
          currentGroup.model.rotation.y -= Math.sin(this.time * 0.0003) / 1200;
        }
      } else if (this.counter !== 0) {
        this.counter = 0;
      }
    }

    Renderer.render(Scene, Camera);
  }

  resize() { // eslint-disable-line
    Renderer.setSize(window.innerWidth, window.innerHeight);

    Camera.aspect = window.innerWidth / window.innerHeight;
    Camera.updateProjectionMatrix();
  }
}
